<template>
  <el-form :ref="formname" :model="form" :rules="rules" label-width="200px" class="etms-router-form">
    <el-form-item label="登录账号 ：">
      <el-input size="mini" v-model="form.LoginName" :disabled="true" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item prop="LoginPassword" label="登录密码 ：">
      <el-input size="mini" type="password" v-model="form.LoginPassword" :disabled="!editpassword" class="el-width-350"></el-input>
      <el-checkbox size="mini" v-model="editpassword">修改密码</el-checkbox>
    </el-form-item>
    <el-form-item prop="Name" label="姓名 ：">
      <el-input size="mini" v-model="form.Name" placeholder="填写账号拥有者姓名" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item prop="NickName" label="昵称 ：">
      <el-input size="mini" v-model="form.NickName" placeholder="填写账号使用者网名" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item prop="Sex" label="性别 ：">
      <el-select size="mini" placeholder="您的性别" v-model="form.Sex">
        <el-option v-for="item in constant.sexs" :label="item.label" :value="item.value" :key="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="Birthday" label="生日 ：">
      <el-date-picker size="mini" v-model="form.Birthday" placeholder="请选择日期" type="date"></el-date-picker>
    </el-form-item>
    <el-form-item prop="Region" label="地区 ：">
      <el-cascader size="mini" v-model="form.Regions" :options="regionmodule.regions" placeholder="请选择所在省市区" filterable clearable class="el-width-350"></el-cascader>
    </el-form-item>
    <el-form-item prop="Street" label="街道 ：">
      <el-input size="mini" v-model="form.Street" placeholder="填写所在街道" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item prop="Address" label="地址 ：">
      <el-input size="mini" v-model="form.Address" placeholder="填写所在详细住址" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item prop="MobilePhone" label="手机号码 ：">
      <el-input size="mini" v-model="form.MobilePhone" placeholder="账号拥有者手机号码" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item prop="Email" label="邮箱 ：">
      <el-input size="mini" v-model="form.Email" placeholder="账号拥有者邮箱" class="el-width-350"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button size="mini" type="primary" @click="submitUserInfo">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    var loginPasswordVali = (rule, value, callback) => {
      if (this.editpassword) {
        if (value === '') {
          callback(new Error('请输入密码'))
        }
        if (value.length < 5 || value.length > 20) {
          callback('长度在5到20个字符')
        }
      }
      callback()
    }
    return {
      formname: 'userform',
      editpassword: false,
      userinfo: this.$cookies.get('userinfo'),
      departments: [],
      positions: [],
      form: {
        UserId: '',
        EnterpriseId: '',
        LoginName: '',
        LoginPassword: '',
        NickName: '',
        Name: '',
        Sex: '',
        Birthday: '',
        Regions: [],
        Street: '',
        Address: '',
        Email: '',
        MobilePhone: '',
        OptimisticLock: '',
        NewOptimisticLock: ''
      }, rules: {
        Name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
        ],
        NickName: [
          { required: true, message: '请填写昵称(网名)', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
        ],
        LoginPassword: [
          { validator: loginPasswordVali, trigger: 'blur' }
        ],
        Sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        Birthday: [
          { required: true, message: '请选择生日', trigger: 'blur' },
        ],
        Regions: [
          { required: true, message: '请选择城市', trigger: 'change' }
        ],
        Street: [
          { required: true, message: '请填写所在街道', trigger: 'blur' },
          { max: 30, message: '长度在30个字符内', trigger: 'blur' }
        ],
        Address: [
          { required: true, message: '请填写详细地址', trigger: 'blur' },
          { max: 100, message: '长度在100个字符内', trigger: 'blur' }
        ],
        MobilePhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' }
        ],
        Email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
        ]
      }
    }
  },
  mounted () {
    if (this.userinfo !== null && this.userinfo !== undefined) {
      this.getDepartment()
      this.getPosition()
      this.getUserInfo()
    }
  },
  methods: {
    getDepartment () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken
      }
      var self = this
      this.$ajax.post(this.constant.openPaths.getDepartmentList, data).then(res => {
        if (res.data.code === 200) {
          self.departments = res.data.result
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(error => {
        self.$message.error(error)
      })
    },
    getPosition () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken
      }
      var self = this
      this.$ajax.post(this.constant.openPaths.getPositionList, data).then(res => {
        if (res.data.code === 200) {
          self.positions = res.data.result
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(error => {
        self.$message.error(error)
      })
    },
    getUserInfo () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken
      }

      var self = this
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.getCurrentUserInfo,
        data: data
      }
      ).then(res => {
        if (res.data.code === 200) {
          var result = res.data.result
          self.form.UserId = result.userId
          self.form.OptimisticLock = result.optimisticLock
          self.form.EnterpriseId = result.enterpriseId
          self.form.LoginName = result.loginName
          self.form.Name = result.name
          self.form.NickName = result.nickName
          self.form.Sex = result.sex ? '1' : '0'
          self.form.Birthday = result.birthday

          if (result.regions !== '' && result.regions !== undefined && result.regions !== null)
            self.form.Regions = result.regions.split(',')
          self.form.Street = result.street
          self.form.Address = result.address
          self.form.MobilePhone = result.mobilePhone
          self.form.Email = result.email
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(error => {
        self.$message.error(error)
      })
    },
    submitUserInfo () {
      this.$refs[this.formname].validate(vali => {
        if (vali) {
          var self = this
          this.$ajax.post(this.constant.openPaths.submitUserInfo, {
            UserId: this.userinfo.id,
            EnterpriseId: this.userinfo.enterpriseId,
            LoginToken: this.userinfo.loginToken,
            OptimisticLock: this.form.OptimisticLock,
            LoginName: this.form.LoginName,
            LoginPassword: this.editpassword ? this.form.LoginPassword : '',
            NickName: this.form.NickName,
            Name: this.form.Name,
            Sex: this.form.Sex,
            Birthday: this.form.Birthday,
            Regions: this.form.Regions,
            Street: this.form.Street,
            Address: this.form.Address,
            Email: this.form.Email,
            MobilePhone: this.form.MobilePhone
          }).then(res => {
            if (res.data.code === 200) {
              self.form.OptimisticLock = res.data.result
              self.$message({ message: res.data.msg, type: 'success' })
            }
            else {
              self.$message.error(res.data.msg)
            }
          }).catch(error => {
            self.$message.error(error)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/personal_info.vue